export default __webpack_public_path__ + "static/media/FOTO-01.15bb9f29.jpg";